
import {useSelector} from "react-redux";


const Profit = (props) => {
	const {DataCompany, User} = useSelector(state => state.auth);
	console.log(User)
	if (!DataCompany?.Token) {
		return <></>;
	}

	return (
		<iframe 
			title="unique"
			src={`${process.env.REACT_APP_IFRAME_V2_URL}/lucro?token=${DataCompany.Token}&moduleId=${process.env.REACT_APP_MODULE_ID}&email=${User.UserName}&timestamp=${new Date().getTime()}&userId=10`}
        	style={{
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				maxHeight: '100%',
				position: "border: none"
			}}        
        />
	);
};

export default Profit;
